<h2>
    {{ componentTitle }}
    <button class="icon--add btn--default" type="button" (click)="editIdentification()" *ngIf="(true == canEdit) && hasAccessControlClaim()">Add Identification</button>
    <button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)">View History</button>
</h2>
<p-table #dt
         styleClass="p-datatable-striped"
         [value]="identifications">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Type</th>
            <th>ID Number</th>
            <th>Location Code</th>
            <th class="w--date">Effective Date</th>
            <th class="w--date">Expiration Date</th>
            <th class="w--icon" *ngIf="canEdit">Edit</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="5 + (!!canEdit ? 1 : 0)">
                No records found
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
        <tr [pSelectableRow]="data">
            <td>{{ data.identificationType }}</td>
            <td>{{ formatIdentificationValue(data) }}</td>
            <td>{{ data.locationCode }}</td>
            <td>{{ data.effectiveDate | shortDate }}</td>
            <td>{{ data.endDate | shortDate }}</td>
            <td class="text-center" *ngIf="canEdit">
                <a class="icon--edit" title="Edit Identification" href="javascript:void(0);" (click)="editIdentification(data.id)" *ngIf="data.allowEdit && canEditIdentType(data.customerIdentificationTypeId) && canEditIdentificationType(data.customerIdentificationTypeId)"></a>
            </td>
        </tr>
    </ng-template>
</p-table>